import { IAppState } from '../../redux';

export function selectIsInsufficientFunds(state: IAppState): boolean {
  return !!state.checkoutInfo.isInsufficientFunds;
}
